import { AiFillEdit } from "react-icons/ai";
import { useAppContext } from "../../context/appContext";
import Wrapper from "../../assets/wrappers/Location";
import PermissionGuard from "../PermissionGuard";

const ItemKitchen = ({ itemKitchen }) => {
  const { setEditItemKitchen } = useAppContext();

  return (
    <Wrapper>
      <div className="item-location">
        <b>{itemKitchen.kitchenName}</b>
        <PermissionGuard permission="editItemKitchens">
          {itemKitchen.kitchenName !== "Default" && (
            <button
              className="item-location-button"
              onClick={() => setEditItemKitchen(itemKitchen._id)}
            >
              <AiFillEdit />
            </button>
          )}
        </PermissionGuard>
      </div>
    </Wrapper>
  );
};

export default ItemKitchen;
